import { Logger } from '../logger/Logger';

import { URLUtilities } from './url';

export function redirectParentIframe(redirectUrl: string): void {
  if (!redirectUrl) return;

  if (!URLUtilities.isUrlValid(redirectUrl)) {
    Logger.logFailure('InvalidRedirectUrl', {
      additional: redirectUrl,
    });
    return;
  }

  // Directly access parent window from iframe, because there is no post message API for cross-origin communication.
  // Operator should configure their site to allow cross-origin access from our game iframe for this to work.
  try {
    window.parent.location.href = redirectUrl;
  } catch {
    window.parent.parent.location.href = redirectUrl;
  }
}
